import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type RowValueProps = {
	className?: string;
	style?: React.CSSProperties;
	content?: React.ReactNode | JSX.Element;
};

export const RowValue = ({ className, content, style }: RowValueProps) => {
	return (
		<div className={clsx(styles.rowValue, className)} style={{ ...style }}>
			{content}
		</div>
	);
};
